<div
  class="king-user-wrapper"
  [class.active]="!!user()"
  [class.clickable]="!user()"
  (click)="!user() && openDepositModal()"
>
  <div class="hp-side__player">
    @if (isChallenger()) {
      <ng-container *ngTemplateOutlet="roleIcon" />
    }
    {{ user() ? user()!.name : role().toUpperCase() }}
    @if (!isChallenger()) {
      <ng-container *ngTemplateOutlet="roleIcon" />
    }
  </div>
  @if (user()) {
    <app-king-glow-svg animate.enter="fade-in" class="waiting-img" [class.challenger]="isChallenger()" [isChallenger]="isChallenger()" />
  }
  <app-king-user-avatar [kingUser]="user()" [isChallenger]="isChallenger()"/>
</div>
<div class="weapon-side">
  @if (attackAnimation()) {
    <app-king-weapon
      animate.enter="fade-in"
      class="weapon-side__animation"
      [weapon]="attackAnimation()!"
      [reverse]="isChallenger()"
    ></app-king-weapon>
  }
</div>

<ng-template #roleIcon>
    <svg-icon
            class="flex items-center justify-center s-24 color"
            [src]="iconSrc()"
    ></svg-icon>
</ng-template>
